import { createFileRoute } from "@tanstack/react-router";
import BeatingProcrastinationGuide from "@/pages/resources/BeatingProcrastinationGuide";

export const Route = createFileRoute("/learn/beating-procrastination")({
  head: () => ({
    meta: [
        {
            "title": "Beating Procrastination: Science-Based Strategies | System Atlas"
        },
        {
            "name": "description",
            "content": "Understand why you procrastinate and learn proven strategies to overcome it. From the 2-minute rule to environment design, take control of your productivity."
        },
        {
            "property": "og:title",
            "content": "Beating Procrastination: Science-Based Strategies | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Understand why you procrastinate and learn proven strategies to overcome it. From the 2-minute rule to environment design, take control of your productivity."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/beating-procrastination"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Beating Procrastination: Science-Based Strategies | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Understand why you procrastinate and learn proven strategies to overcome it. From the 2-minute rule to environment design, take control of your productivity."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/beating-procrastination"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/beating-procrastination"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/beating-procrastination"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/beating-procrastination"
        }
    ],
  }),
  component: BeatingProcrastinationGuide,
});
